import { IFormatSpecification } from "../IFormatSpecification";
import { IClaioMediaDrawableObject } from "../objects";
import { AbstractImageDrawableObjectEditor } from "./AbstractImageDrawableObjectEditor";

export abstract class AbstractClaioMediaDrawableObjectEditor<TObject extends IClaioMediaDrawableObject> extends AbstractImageDrawableObjectEditor<TObject> {
  constructor(source: TObject | AbstractClaioMediaDrawableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    // TODO: 独自プロパティの実装.
  }
}
